<template>
    <div class="article-container">
        <img class="base-banner" v-src="'https://oss.cloud.custouch.com/res/11274/技术文章@3x.png'" />
        <div class="content">
            <h4>{{ title }}</h4>
            <van-search v-model="value" placeholder="请输入搜索内容"></van-search>
        </div>
        <van-tabs v-model="curCategory" animated="animated" @change="onTabChange">
            <van-tab :title="item.name" :name="item.id" v-for="item in categoryGroup" :key="item.id">
            </van-tab>
        </van-tabs>
        <ListTransition :list="list" rowKey="id" style="padding:0 1rem" v-slot="{ item }">
            <div class="item">
                <div class="text" @click="jumpTo(item)">
                    <div class="name">{{ item.name }}</div>
                    <div class="intro">{{ item.intro }}</div>
                </div>
                <div class="banner" v-lazy:background-image="item.img">
                    <div class="star-wrapper" @click="star(item)">
                        <van-icon class="star" :name="bookDic[item.id] ? 'star' : 'star-o'"></van-icon>
                    </div>
                </div>
            </div>
        </ListTransition>
    </div>
</template>

<script>
import ListTransition from './components/ListTransition'
import bookMarksAction from '@/views/mixins/bookMarksAction'
const { CMS } = window.env
import { sleep } from '@/utils/common'
import {
    getDataRows,
    getDataHierarchies,
    concatWithSymbol
} from '@custouch/proxy-use'
export default {
    mixins: [bookMarksAction],
    name: 'articleList',
    props: ['title', 'mId'],
    components: {
        ListTransition
    },
    data() {
        return {
            article: { [this.mId]: [] },
            curCategory: this.mId,
            categoryGroup: [{ id: this.mId, name: '全部' }],
            value: ''
        }
    },
    computed: {
        list() {
            if (!this.value) return this.article[this.curCategory]
            return this.article[this.curCategory]?.filter(item =>
                (item.tag || [])
                    .concat(item.name)
                    .toString()
                    .includes(this.value)
            )
        }
    },
    methods: {
        async jumpTo(item) {
            if (!item.link) return
            this.$root.$emit('actionview', {
                info: {
                    title: concatWithSymbol([this.title]),
                    remark: `点击技术文章-${item.name}`,
                    to: item.link
                },
                actionType: 'clickview'
            })
            await sleep(50)
            window.location.href = item.link
        },
        async onTabChange(hId) {
            this.$root.$emit('actionview', {
                info: {
                    title: concatWithSymbol([
                        this.title,
                        hId !== this.mId
                            ? this.categoryGroup.find(t => t.id === hId).name
                            : null
                    ])
                },
                actionType: 'pageview'
            })
            if (!this.article[hId]) {
                this.$set(
                    this.article,
                    hId,
                    (
                        await getDataRows({
                            dataModuleId: this.mId,
                            dataHierarchyId: hId == this.mId ? null : hId,
                            dataTemplateId: CMS.template.article,
                            index: 1,
                            size: 999,
                            recursive: true,
                            orderBy: 'date',
                            desc: true
                        })
                    ).data.map(t => t.detail)
                )
            }
        }
    },
    async created() {
        this.bindBookMarks()
        const [dataHierarchies, { data: articles }] = await Promise.all([
            getDataHierarchies(this.mId),
            getDataRows({
                dataModuleId: this.mId,
                dataTemplateId: CMS.template.article,
                index: 1,
                size: 999,
                recursive: true,
                orderBy: 'date',
                desc: true
            })
        ])
        this.categoryGroup.push(...dataHierarchies)
        this.article[this.mId] = articles.map(t =>
            Object.assign(t.detail, {
                dataRowId: t.id,
                section: '技术文章'
            })
        )
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/style/mixin.less';

.content {
    padding: 1rem;
}

.van-search {
    padding: 0;
}

.item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    line-height: 1.1rem;
    border-bottom: 1px solid #ebebeb;
    padding: 0.6rem 0;

    .text {
        width: 70%;
        padding-right: 1rem;

        .name {
            .ellipsis;
        }

        .intro {
            color: #b1b2b1;
            font-size: 0.65rem;
            margin-top: 0.2rem;
            .ellipsis(false, 2);
        }
    }

    .banner {
        width: 30%;
        height: 3.6rem;
        background: transparent no-repeat center/cover;
        position: relative;

        .star-wrapper {
            cursor: pointer;
            position: absolute;
            right: -0.4rem;
            top: 0.4rem;
            background: url('~@/assets/imgs/组 329@3x.png') no-repeat center/contain;
            width: 1.3rem;
            height: 1.1rem;
            color: @blue;
            .flex();
            justify-content: center;
            padding-top: 0.2rem;
            font-size: 0.6rem;
        }
    }
}
</style>
